const breakpoints = {
  base: '0px',
  sm: '550px',
  md: '768px',
  lg: '1280px',
  xl: '1440px',
  '2xl': '1600px',
};

export default breakpoints;
